import { TFunction } from 'i18next';

export const tqEnTitles = (t: TFunction): Record<string, string> | undefined => {
  return {
    timelinessResponseStats: t(
      'tqen_response_timeliness',
      'Timeliness of Consultation Responses'
    ),
    lateResponseStatItems: t('tqen_late_responses', 'Late Responses'),
    timeframeExceededStats: t('tqen_timeframe_exceeded', 'Timeframe Exceeded – Breakdown'),
    agreedExtensionStats: t('agreed_extensions', 'Breakdown of Agreed Extensions'),
    outstandingResponseStats: t(
      'tqen_number_of_outstanding_responses',
      'Number of outstanding responses'
    ),
    totalAppealConsultationsReceived: t(
      'tqen_total_appeal_consultations_received',
      'Total number of Appeal consultations'
    ),
    averageDaysTakenToRespondToAppealConsultations: t(
      'tqen_average_days_taken_to_respond_to_appeal_consultations',
      'Average number of days taken to respond to Appeal consultations'
    ),
  };
};
